module.exports = __webpack_public_path__ + "img/default-avatar.1a433666.svg";